module.exports = __webpack_public_path__ + "img/scene-1.74cb464.png";